export default function setSelectYear(dateSelect) {
    const select = dateSelect.parentNode.querySelector('select');
    if (!select) {
        return;
    }

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) {
        return;
    }

    const group = selectedOption.parentNode;
    if (group && group.nodeName === 'OPTGROUP' && group.hasAttribute('label')) {
        dateSelect.setAttribute('value', group.getAttribute('label'));
    }
}
